var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Button, Dropdown } from "semantic-ui-react";
import user_model from "models/user_model";
import kb_model from "models/kb_model";
const KBSelectParent = ({ parent, kbid, onSelect, placeholder, show_loading }) => {
    const [treeData, setTreeData] = useState(null);
    useEffect(() => {
        const loadTree = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!user_model.limit_access("kb_admin"))
                return;
            const kb_tree = yield kb_model.get_kb_tree();
            setTreeData(kb_tree);
        });
        loadTree();
    }, []);
    if (!treeData)
        return _jsx(_Fragment, { children: "Loading" });
    // Ensure value is never null for Dropdown
    const dropdownValue = parent === null ? undefined : parent;
    // Fallback KBTreeItem for reset or not found
    const fallbackItem = { kbid: null, name: "" };
    return (_jsxs("div", { className: "flex gap-4", children: [_jsx(Dropdown, { clearable: true, placeholder: placeholder, selection: true, search: true, value: dropdownValue, onChange: (_, d) => {
                    const selected = treeData.find(o => o.kbid === d.value);
                    onSelect(selected !== null && selected !== void 0 ? selected : fallbackItem);
                }, loading: show_loading, options: treeData
                    .filter(o => o.kbid !== kbid && o.kbid !== null)
                    .map(s => ({ key: "md_" + s.kbid, value: s.kbid, text: s.name })) }), _jsx(Button, { primary: true, onClick: () => onSelect(fallbackItem), children: "Reset" })] }));
};
export default KBSelectParent;
